import React from 'react';
import p from 'translation';
import { App } from 'core/types/app';

import { ReactComponent as ClockIcon } from './icon/clock.svg';
import { ReactComponent as TemplateIcon } from './icon/apps.svg';

import icon from './icon.svg';

const clock: App = {
  id: 'clock',
  name: p.t('apps.clock.title'),
  icon,
  color: {
    main: '#C90859',
    light: '#FF5285',
    dark: '#920030',
    contrastText: '#fff',
  },
  app: React.lazy(() => import(/* webpackChunkName: "clock" */ './app')),
  navigation: [
    {
      title: p.t('apps.clock.overview-page.title'),
      path: '/',
      hasAccess: () => true,
      icon: <ClockIcon />,
      forceActive: () => window.location.href.includes('/clock/clock/'),
    },
    {
      title: p.t('apps.clock.templates.title'),
      path: '/templates',
      hasAccess: () => true,
      icon: <TemplateIcon />,
      forceActive: () => window.location.href.includes('/templates/'),
    },
  ],
};

export default clock;
